import React from 'react';
import { styled } from 'styled-components';
import { Card } from './Card';
import { CardContainer } from './CardContainer';
import servalImage from '../images/serval/product-photos-serval-6.webp';
import bengalImage from '../images/bengal/bengal-front.webp';
import blackfootImage from '../images/blackfoot/blackfoot-thumbnail.webp'
import { PageTitle } from './PageTitle';
import { StandardSection, StandardSectionContentContainer } from './StandardSection';
import { PageDescription } from './PageDescription';

const FrameCard = styled(Card)`
    @media only screen and (min-width: ${(props) => props.theme.breakpoints.second}) {
        flex: 0 1 calc((100% - 3rem) / 2);
    }
`;

export const FramesSection = () => (
    <StandardSection>
        <StandardSectionContentContainer>
            <PageTitle>Frames</PageTitle>
			<PageDescription>
				Open source frame kits that you can either buy from us in a complete package, or cut and print yourself.
			</PageDescription>
            <CardContainer>
                <FrameCard 
                    to="/frames/serval" 
                    background={servalImage} 
                    title="Serval" 
                    description="A perfectly balanced 5-inch racing frame. Tough, practical, easy to build, and fully open source."
                />
                <FrameCard 
                    to="/frames/bengal" 
                    background={bengalImage} 
                    title="Bengal" 
                    description="A fun and friendly 2.5-inch toothpick."
                />
                <FrameCard 
                    to="/frames/blackfoot" 
                    background={blackfootImage} 
                    title="Blackfoot" 
                    description="A super-tiny 3D-printable frame."
                />
            </CardContainer>
        </StandardSectionContentContainer>
    </StandardSection>
);